import { LinkerPlugin } from "../editor-plugins/linker/LinkerPlugin";
import { IToolbarItem } from "./interfaces/IToolbarItem";

export const linker: IToolbarItem = {
    name: "linker",
    pluginConfig: null,
    plugins: [LinkerPlugin],
    registeredCommands: [LinkerPlugin.linkCommand, LinkerPlugin.unlinkCommand]
};
